<div class="textarea">
  <mat-form-field
    [ngClass]="{
      'custom-label': !isMaterialLabel,
      'is-multi-line': rows > 1 || canResize
    }"
  >
    <mat-label *ngIf="isMaterialLabel && label">{{ label }}</mat-label>
    <textarea
      (change)="valueChanged()"
      [formControl]="control"
      [id]="inputId"
      [ngClass]="{ 'no-resize': !canResize }"
      [placeholder]="placeholder"
      [readonly]="isDisabled"
      [rows]="rows"
      matInput
    ></textarea>
    <span *ngIf="characterCountLimit" matTextSuffix>
      {{ control.value?.length ?? 0 }}/{{ characterCountLimit }}
      characters
    </span>
    <mat-error *ngIf="control.hasError('maxlength')">
      Value should not contain more than
      {{ control.errors?.['maxlength']?.['requiredLength'] }} characters
    </mat-error>
    <mat-error *ngIf="control.hasError('emptyString')">
      Please enter a valid {{ label }}.
    </mat-error>
  </mat-form-field>
</div>
